import { defineStore } from 'pinia';
import http from './http';
import { Response } from '@/types';
import { useMenuStore } from './menu';
import { useAuthStore } from '@/plugins';
import { useLoadingStore } from './loading';
import { message, TableColumnType } from 'ant-design-vue';

export interface Profile {
  account: Account;
  permissions: string[];
  role: string;
}
export interface Account {
  username: string;
  avatar: string;
  gender: number;
}

export type TokenResult = {
  token: string;
  name: string;
  roleName: string;
  expires: number;
};
export const useAccountStore = defineStore('account', {
  state() {
    return {
      account: {} as Account,
      permissions: [] as string[],
      role: '',
      logged: true,
    };
  },
  actions: {
    async login(username: string, password: string) {
      return http
        .request<TokenResult, Response<TokenResult>>(
          `/pinkfish/portal/portalUser/login`,
          'POST_JSON',
          {
            phone: username,
            password: password,
          }
        )
        .then(async (response) => {
          if (response.code === 200) {
            localStorage.setItem('admin', response.data.name);
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('roleName', response.data.roleName || '');
            this.role = response.data.roleName || '';
            this.logged = true;
            let currentDate = new Date();
            let oneDayInMilliseconds = 24 * 60 * 60 * 1000;
            let newDate = new Date(currentDate.getTime() + oneDayInMilliseconds);
            http.setAuthorization(`${response.data.token}`, newDate);
            // 确保角色信息已保存后再加载菜单
            await new Promise(resolve => setTimeout(resolve, 0));
            await useMenuStore().getMenuList();
            return response.data;
          } else {
            message.error(response.message);
            return Promise.reject(response);
          }
        });
    },
    async logout() {
      return new Promise<boolean>((resolve) => {
        localStorage.removeItem('stepin-menu');
        http.removeAuthorization();
        this.logged = false;
        resolve(true);
      });
    },
    async profile() {
      const { setAuthLoading } = useLoadingStore();
      setAuthLoading(true);
      // return http
      //   .request<Account, Response<Profile>>('/barcode/account', 'get')
      //   .then((response) => {
      //     if (response.code === 0) {
      //       const { setAuthorities } = useAuthStore();
      //       const { account, permissions, role } = response.data;
      //       this.account = account;
      //       this.permissions = permissions;
      //       this.role = role;
      //       setAuthorities(permissions);
      //       return response.data;
      //     } else {
      //       return Promise.reject(response);
      //     }
      //   })
      //   .finally(() => setAuthLoading(false));
    },
    setLogged(logged: boolean) {
      this.logged = logged;
    },
  },
});
